<div id="zoom-control-container" class="rds-component-group">
  <button rds-icon-button size="m" class="zoom-button" (click)="zoom(-zoomStep)">
    <rds-icon icon="zoom_out"></rds-icon>
  </button>
  <rds-slider [min]="30" [max]="100" [step]="zoomStep" [tickInterval]="10" [formControl]="form.controls.zoom"> </rds-slider>
  <button rds-icon-button size="m" class="zoom-button" (click)="zoom(zoomStep)">
    <rds-icon icon="zoom_in"></rds-icon>
  </button>
</div>
